import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import Scheduler from './pages/Scheduler';
import Inbox from './pages/Inbox';
import Analytics from './pages/Analytics';
import Listening from './pages/Listening';
import ReportBuilder from './pages/ReportBuilder';
import Settings from './pages/Settings';
import Posts from './pages/Posts';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DataDeletion from './pages/DataDeletion';
import ToastContainer from './components/Toast/ToastContainer';
import SessionExpiredModal from './components/SessionExpiredModal/SessionExpiredModal';
import { setSessionExpiredCallback } from './api/client';

function App() {
  const [sessionExpired, setSessionExpired] = useState(false);

  const handleSessionExpired = useCallback(() => {
    setSessionExpired(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setSessionExpired(false);
  }, []);

  // Set the callback for the API client
  React.useEffect(() => {
    setSessionExpiredCallback(handleSessionExpired);
  }, [handleSessionExpired]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/scheduler" element={<Scheduler />} />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/listening" element={<Listening />} />
        <Route path="/report-builder" element={<ReportBuilder />} />
        <Route path="/settings" element={<Settings />} />          <Route path="/posts" element={<Posts />} />        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/data-deletion" element={<DataDeletion />} />
      </Routes>
      <ToastContainer />
      {sessionExpired && <SessionExpiredModal onClose={handleCloseModal} />}
    </Router>
  );
}

export default App;
